import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

function saveObjArr(name, data) {
  localStorage.setItem(name, JSON.stringify(data))
}
function getObjArr(name) {
  return JSON.parse(localStorage.getItem(name))
}

const userInfo = getObjArr('userInfo') ? getObjArr('userInfo') : {}
const partyInfo = getObjArr('partyInfo') ? getObjArr('partyInfo') : {}

const state = {
  token: getToken(),
  name: userInfo.username,
  avatar: '',
  userInfo,
  partyInfo,
  menu: [],
  trackingNo: ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USERINFO: (state, info) => {
    state.userInfo = info
  },
  SET_PARTYINFO: (state, info) => {
    state.partyInfo = info
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_MENU: (state, menu) => {
    state.menu = menu
  },
  SET_TRACKING_NO: (state, tranking) => {
    state.trackingNo = tranking
  }
}

const actions = {
  set_token({ commit }, sessionId) {
    commit('SET_TOKEN', sessionId)
    setToken(sessionId)
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resetRouter()
      resolve()
    })
  },
  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', '')
      commit('SET_USERINFO', [])
      commit('SET_NAME', '')
      commit('SET_MENU', [])
      localStorage.removeItem('menu')
      removeToken()
      localStorage.removeItem('userInfo')
      resetRouter()
      resolve()
    })
  },
  clearStroage({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  },
  // get userInfo
  set_userInfo({ commit }, data) {
    return new Promise((resolve, reject) => {
      const userInfo = data.authUser
      if (!userInfo) {
        reject('Verification failed, please Login again.')
      }
      const { sessionId } = userInfo
      commit('SET_TOKEN', sessionId)
      setToken(sessionId)
      commit('SET_USERINFO', userInfo)
      saveObjArr('userInfo', userInfo)
      const partyInfo = data.party || {}
      commit('SET_PARTYINFO', partyInfo)
      saveObjArr('partyInfo', partyInfo)
      commit('SET_NAME', userInfo.username)
      resolve(userInfo)
    })
  },
  set_menuList({ commit, rootGetters, state }, data) {
    return new Promise((resolve, reject) => {
      const menu = data
      commit('SET_MENU', menu)
      saveObjArr('menu', menu)
      resolve(menu)
    })
  },
  set_trackingNo({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_TRACKING_NO', data)
      resolve(data)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

